/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-users
 * Fiona User Service
 *
 * The version of the OpenAPI document: 0.1.57
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Favorite,
    FavoriteFilter,
    FavoriteWithoutIdUser,
    UnfavoriteRequestBody,
} from '../models';

export interface FavoritesControllerAddFavoriteRequest {
    favoriteWithoutIdUser?: FavoriteWithoutIdUser;
}

export interface FavoritesControllerGetAllFavoritesRequest {
    filter?: FavoriteFilter;
}

export interface FavoritesControllerGetFavoriteByIdRequest {
    id: string;
}

export interface FavoritesControllerRemoveFavoriteRequest {
    unfavoriteRequestBody?: UnfavoriteRequestBody;
}

/**
 * FavoritesControllerApi - interface
 * 
 * @export
 * @interface FavoritesControllerApiInterface
 */
export interface FavoritesControllerApiInterface {
    /**
     * 
     * @param {FavoriteWithoutIdUser} [favoriteWithoutIdUser] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesControllerApiInterface
     */
    favoritesControllerAddFavoriteRaw(requestParameters: FavoritesControllerAddFavoriteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Favorite>>;

    /**
     */
    favoritesControllerAddFavorite(requestParameters: FavoritesControllerAddFavoriteRequest, initOverrides?: RequestInit): Promise<Favorite>;

    /**
     * 
     * @param {FavoriteFilter} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesControllerApiInterface
     */
    favoritesControllerGetAllFavoritesRaw(requestParameters: FavoritesControllerGetAllFavoritesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Favorite>>>;

    /**
     */
    favoritesControllerGetAllFavorites(requestParameters: FavoritesControllerGetAllFavoritesRequest, initOverrides?: RequestInit): Promise<Array<Favorite>>;

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesControllerApiInterface
     */
    favoritesControllerGetFavoriteByIdRaw(requestParameters: FavoritesControllerGetFavoriteByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Favorite>>;

    /**
     */
    favoritesControllerGetFavoriteById(requestParameters: FavoritesControllerGetFavoriteByIdRequest, initOverrides?: RequestInit): Promise<Favorite>;

    /**
     * 
     * @param {UnfavoriteRequestBody} [unfavoriteRequestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoritesControllerApiInterface
     */
    favoritesControllerRemoveFavoriteRaw(requestParameters: FavoritesControllerRemoveFavoriteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>>;

    /**
     */
    favoritesControllerRemoveFavorite(requestParameters: FavoritesControllerRemoveFavoriteRequest, initOverrides?: RequestInit): Promise<any>;

}

/**
 * 
 */
export class FavoritesControllerApi extends runtime.BaseAPI implements FavoritesControllerApiInterface {

    /**
     */
    async favoritesControllerAddFavoriteRaw(requestParameters: FavoritesControllerAddFavoriteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Favorite>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/favorites`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.favoriteWithoutIdUser,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async favoritesControllerAddFavorite(requestParameters: FavoritesControllerAddFavoriteRequest = {}, initOverrides?: RequestInit): Promise<Favorite> {
        const response = await this.favoritesControllerAddFavoriteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async favoritesControllerGetAllFavoritesRaw(requestParameters: FavoritesControllerGetAllFavoritesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<Favorite>>> {
        const queryParameters: any = {};

        if (requestParameters.filter !== undefined) {
            queryParameters['filter'] = requestParameters.filter;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/favorites`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async favoritesControllerGetAllFavorites(requestParameters: FavoritesControllerGetAllFavoritesRequest = {}, initOverrides?: RequestInit): Promise<Array<Favorite>> {
        const response = await this.favoritesControllerGetAllFavoritesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async favoritesControllerGetFavoriteByIdRaw(requestParameters: FavoritesControllerGetFavoriteByIdRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Favorite>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling favoritesControllerGetFavoriteById.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/favorites/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async favoritesControllerGetFavoriteById(requestParameters: FavoritesControllerGetFavoriteByIdRequest, initOverrides?: RequestInit): Promise<Favorite> {
        const response = await this.favoritesControllerGetFavoriteByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async favoritesControllerRemoveFavoriteRaw(requestParameters: FavoritesControllerRemoveFavoriteRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("keycloak", []);
        }

        const response = await this.request({
            path: `/api/favorites`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.unfavoriteRequestBody,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async favoritesControllerRemoveFavorite(requestParameters: FavoritesControllerRemoveFavoriteRequest = {}, initOverrides?: RequestInit): Promise<any> {
        const response = await this.favoritesControllerRemoveFavoriteRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
